import type { Folder } from '@seen/core/models/document-references/folder'
import { useMemo } from 'react'
import { useFolders } from '#src/components/document-reference/useFolders.ts'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'

// The folders the current practitioner has a role for, and the ids of those
// they do not. Every reader that lists documents applies this: a folder's
// documents are requested only when it is visible, or excluded by id when not.
export function useFolderAccess(): {
  visibleFolders: Folder[]
  hiddenFolderIds: string[]
} {
  const practitioner = useCurrentPractitioner()
  const folders = useFolders()
  return useMemo(() => {
    const visibleFolders = folders.filter((folder) =>
      practitioner.isRole(...folder.roles)
    )
    return {
      visibleFolders,
      hiddenFolderIds: folders
        .filter((folder) => !visibleFolders.includes(folder))
        .map((folder) => folder.id),
    }
  }, [folders, practitioner])
}
